<template>
  <div class="live-mina">
    <div class="live-wrapper">
      <div class="top">
        <div class="left">
          <div class="textarea">
            <EditTextarea placeholder="今天的心情、趣事等..." :limit="500" ref="textarea"></EditTextarea>
          </div>
        </div>
        <div class="right">
          <el-popconfirm title="确认发送?" placement="bottom" @confirm="submit">
            <el-button slot="reference" type="primary" class="send" :loading="disabled || locationFlag">发布</el-button>
          </el-popconfirm>
        </div>
      </div>

      <div class="toolbar">
        <div class="toolbar-left">
          <FaceBtn class="toolbar-item" ref="face" @click="addFace" title="添加表情" v-if="enableFace"></FaceBtn>
          <ImgBtn class="toolbar-item" @click="addPictures" title="添加图片" v-if="enablePictureUpload"></ImgBtn>
          <VideoBtn class="toolbar-item" @click="addVideos" title="添加视频" v-if="enableVideoUpload"></VideoBtn>
          <AtBtn class="toolbar-item" @click="at" ref="at" title="@好友" v-if="enableAt"></AtBtn>
          <LocationBtn class="toolbar-item" @click="getLocation" title="获取定位" v-if="enableLocation"></LocationBtn>
          <el-tag class="location-text" type="info" v-show="locationFlag" size="mini" :disable-transitions="true"><i
            class="el-icon-loading"></i><span>定位中</span></el-tag>
          <el-tag class="location-text" type="danger" v-show="locationFailFlag" size="mini"
                  :disable-transitions="true">定位失败
          </el-tag>
          <el-tag class="location-text" size="mini" v-for="(item, i) in locationTab" :key="item"
                  :closable="i === locationTab.length - 1" :disable-transitions="true" @close="deleteLocation">{{ item
            }}
          </el-tag>
        </div>
        <div class="toolbar-right">
          <el-select v-model="data.visibility" size="mini" @change="visibilityChange"
                     ref="visibility" style="width: 135px;" :popper-append-to-body="false">
            <el-option label="任何人可见" value="ANYONE"></el-option>
            <el-option label="空间访客可见" value="INHERIT_SPACE"></el-option>
            <el-option label="仅好友可见" value="FRIENDLY_ONLY"></el-option>
            <el-option label="部分好友可见" value="FRIENDLY_PART" @click.native="showChooseFriend"></el-option>
            <el-option label="部分好友不可见" value="FRIENDLY_PART_NOT" @click.native="showChooseFriend"></el-option>
            <el-option label="仅自己可见" value="MYSELF_ONLY"></el-option>
          </el-select>
          <SpaceAccessAuthTip :value="data.visibility" :valuesRule="valuesRule"></SpaceAccessAuthTip>
          <el-select v-model="data.delay" placeholder="请选择" size="mini" title="定时发送" style="width: 110px;" :popper-append-to-body="false">
            <el-option label="无延迟" value="NO_DELAY"></el-option>
            <el-option label="30分钟后" value="MINUTE_30"></el-option>
            <el-option label="1小时后" value="HOUR_1"></el-option>
            <el-option label="2小时后" value="HOUR_2"></el-option>
            <el-option label="4小时后" value="HOUR_4"></el-option>
            <el-option label="8小时后" value="HOUR_8"></el-option>
            <el-option label="1天后" value="DAY_1"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <UploadImg
      style="margin-top: 8px"
      v-if="enablePictureUpload"
      v-show="data.pictures.length > 0"
      ref="uploadComponent"
      :uploadOption="ossUploadOption"
      @change="imgChange"
      :defaultImg="data.pictures"
      :customStyle="{'width': '100px', 'height': '110px'}"
      :isAvatarMode="false"
      changeText="更换图片"></UploadImg>
    <VideoUpload ref="videoComponent"
                 v-if="enableVideoUpload"
                 style="background-color: #d2dcfa;margin-top: 8px"
                 :uploadOption="ossUploadOption"
                 :limit="1"
                 @change="videoChange"></VideoUpload>
  </div>
</template>

<script>
    import faceBus from "../../js/bus/faceBus";
    import cropperBus from "../../js/bus/cropperBus";
    import chooseFriendBus from "../../js/bus/chooseFriendBus";
    import EditTextarea from "../baseComponent/EditTextarea"
    import {uuid} from "../../js/utils/uuid";
    import {clone} from "../../js/utils/objUtils";
    import UploadImg from "./UploadImg.vue"
    import setting from "../../config/setting";
    import FaceBtn from "../iconBtn/FaceBtn";
    import ImgBtn from "../iconBtn/ImgBtn";
    import VideoBtn from "../iconBtn/VideoBtn";
    import AtBtn from "../iconBtn/AtBtn";
    import LocationBtn from "../iconBtn/LocationBtn";
    import VideoUpload from "../baseComponent/VideoUpload";
    import bus from "../../js/bus/bus";
    import SpaceAccessAuthTip from "../baseComponent/SpaceAccessAuthTip"

    export default {
        name: "LiveEditor",
        components: {EditTextarea, UploadImg, FaceBtn, ImgBtn, AtBtn, LocationBtn, VideoBtn, VideoUpload, SpaceAccessAuthTip},
        props: {
            //提交状态
            disabled: {
                default: false
            },
            //启用表情添加
            enableFace: {
                default: true
            },
            //启用图片添加
            enablePictureUpload: {
                default: true
            },
            //启用视频添加
            enableVideoUpload: {
                default: true
            },
            //启用好友艾特
            enableAt: {
                default: true
            },
            //启用定位
            enableLocation: {
                default: true
            },
        },
        created() {
            //监听表情选择回调
            faceBus.onCallback(this.faceId, (faceItem) => {
                this.$refs.textarea.addFace(faceItem);
            });
            //监听@回调
            chooseFriendBus.onCallback(this.atId, (uList) => {
                for (let i = 0; i < uList.length; i++) {
                    this.$refs.textarea.addAt(uList[i]);
                }
            });
            //监听可见度回调
            chooseFriendBus.onCallback(this.visibilityId, (uList) => {
                this.visibilityUsers = uList;
                this.data.visibilityList = uList.map(({id}) => {
                    return id;
                });
            });
        },
        deactivated() {
        },
        data() {
            return {
                ossUploadOption: setting.ossUploadOption1,
                //占用表情组件id
                faceId: uuid() + "@face",
                //以@事件占用好友选择面板id
                atId: uuid() + "@at",
                //以可见度选择事件占用好友选择面板id
                visibilityId: uuid() + "@visibility",
                locationFlag: false,
                locationFailFlag: false,
                locationTab: [],
                visibilityUsers: [],
                data: {
                    content: "",
                    delay: "NO_DELAY",
                    visibility: "ANYONE",
                    visibilityList: [],
                    location: null,
                    pictures: [],
                    videos: [],
                },
                valuesRule: {
                    'INHERIT_SPACE': {text: '拥有空间访问权限的用户可见，说说不可被转发', tipsType: '2'},
                    'FRIENDLY_ONLY': {text: '说说不可被转发', tipsType: '2'},
                    'FRIENDLY_PART': {text: '说说不可被转发', tipsType: '2'},
                    'FRIENDLY_PART_NOT': {text: '说说不可被转发', tipsType: '2'},
                    'MYSELF_ONLY': {text: '说说不可被转发', tipsType: '2'},
                }
            }
        },
        methods: {
            submit() {
                this.data.content = this.$refs.textarea.getContent();
                this.$emit("submit", clone(this.data));
            },
            //清除填写内容
            clean() {
                this.data.content = "";
                this.data.delay = "NO_DELAY";
                this.data.visibility = "ANYONE";
                this.data.location = null;
                this.locationTab = [];
                this.visibilityUsers = [];
                this.$refs.textarea.clean();
                if (this.enablePictureUpload)
                  this.$refs.uploadComponent.clean();
                if (this.enableVideoUpload)
                  this.$refs.videoComponent.clean();
            },
            //添加好友
            addFace() {
                faceBus.show(this.faceId, this.$refs.face.$el.getBoundingClientRect());
            },
            addPictures() {
                if (this.uploadVideoFlag) {
                    return this.$im.showMessage("视频说说不能添加图片", {icon: 5});
                }
                this.$refs.uploadComponent.add();
            },
            addVideos() {
                if (this.uploadImgFlag) {
                    return this.$im.showMessage("图片说说不能添加视频", {icon: 5});
                }
                this.$refs.videoComponent.addVideo();
            },
            //@好友
            at() {
                chooseFriendBus.show(this.atId, this.$refs.at.$el.getBoundingClientRect())
            },
            getLocation() {
                if (this.locationFlag) {
                    return
                }
                this.locationFlag = true;
                this.locationFailFlag = false;
                this.locationTab = [];
                this.$im.getLocation((l) => {
                    this.locationFlag = false;
                    this.locationTab = [l.city, l.district];
                    this.data.location = {latitude: l.latitude,
                        longitude: l.longitude, city: l.city, district: l.district};
                }, () => {
                    this.locationFailFlag = true;
                    this.locationFlag = false;
                }, false)
            },
            //删除定位结果的最后一级
            deleteLocation() {
                this.locationTab.splice(this.locationTab.length - 1, 1);
                if (this.locationTab.length === 1) {
                    this.data.location.district = "";
                } else if (this.locationTab.length === 0) {
                    this.data.location = null;
                }
            },
            //图片变更
            imgChange(arr) {
                this.data.pictures = arr;
            },
            //可见度改变
            visibilityChange() {
                this.data.visibilityList = [];
            },
            showChooseFriend() {
                chooseFriendBus.show(this.visibilityId,
                    this.$refs.visibility.$el.getBoundingClientRect(),
                    this.data.visibilityList.map(i => i));
            },
            //修改可见度人员
            visibilityClick() {
                chooseFriendBus.show(this.visibilityId,
                    this.$refs.visibility.$el.getBoundingClientRect(),
                    this.data.visibilityList.map(item => item.id));
            },
            videoChange(arr) {
                this.data.videos = arr;
            },
            //输入框获取焦点
            focus() {
                this.$refs.textarea.focus();
            },
        },
        computed: {
            //当前说说是否是上传图片
            uploadImgFlag() {
                return this.data.pictures.length > 0;
            },
            //当前说说是否是上传视频
            uploadVideoFlag() {
                return this.data.videos.length > 0;
            }
        }
    }
</script>

<style scoped>
  .top {
    display: flex;
  }

  .left {
    flex-grow: 1;
    margin-right: 8px;
  }

  .textarea {
    border: 2px #c7e5eb solid;
    border-radius: 4px;
  }

  .toolbar {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
  }

  .toolbar-left {
    font-size: 0;
    margin-bottom: 8px;
  }

  .toolbar-left > .toolbar-item {
    margin-right: 8px;
  }


  .location-text {
    vertical-align: bottom;
    margin-right: 5px;
    user-select: none;
  }

  .visibility-text {
    font-size: 12px;
    vertical-align: bottom;
  }

  .send {
    height: 74px;
  }

</style>



// WEBPACK FOOTER //
// src/view/component/LiveEditor.vue